import type { Theme } from '@mui/material/styles'

const MuiPaginationItem = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      borderRadius: baseTheme.spacing(0.125),
      fontSize: baseTheme.spacing(0.875),
      fontWeight: 400,
      color: baseTheme.palette.neutral.darkest,

      '&:hover, &:focus': {
        color: baseTheme.palette.neutral.black,
        backgroundColor: baseTheme.palette.neutral.lightest,
      },

      [baseTheme.breakpoints.up('md')]: {
        fontSize: baseTheme.spacing(0.875),
      },

      '&.Mui-selected': {
        color: baseTheme.palette.neutral.black,
        backgroundColor: baseTheme.palette.neutral.light,
      },
      '&.Mui-disabled': {
        color: baseTheme.palette.neutral.main,
        opacity: 1,
      },
    },
  },
})

export default MuiPaginationItem
